var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "section" }, [
            !_vm.isView
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "1" },
                        on: { click: _vm.cancelSave }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.btnSaveEnable,
                          no: "2"
                        },
                        on: { click: _vm.saveBilling }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              [
                _vm.isView
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "3" },
                        on: { click: _vm.cancel }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.canEditBilling &&
                !_vm.isAgentBilling &&
                !_vm.isOcPaymentLock
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "4" },
                        on: { click: _vm.editBilling }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                    )
                  : _vm._e(),
                _vm.isRecheckBilling
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "5px" },
                        attrs: { no: "recheck", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.checkRuleAndConfirm(false)
                          }
                        }
                      },
                      [_vm._v(_vm._s(this.$t("Billing.billing_recheck")))]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingUuid &&
                _vm.$checkPermission([
                  "button_ACTBilling_createInvoiceFromBilling"
                ]) &&
                !_vm.isAgentBilling
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "5" },
                        on: { click: _vm.makeInvoiceEvent }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            !_vm.billing.ar
                              ? _vm.$t("CargoMsg.Cargo_CollectInvoice")
                              : _vm.$t("CargoMsg.Cargo_Invoicing")
                          ) + " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingUuid &&
                _vm.$checkPermission(["button_ACTBilling_writeoffBilling"]) &&
                !_vm.isAgentBilling &&
                _vm.isOcCanWriteOff
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "6" },
                        on: { click: _vm.writeoffHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("Billing.billing_writeOff")) + " ")]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingUuid &&
                !_vm.billing.ar &&
                _vm.$checkPermission([
                  "button_ACTBilling_payauthBillingGroup"
                ]) &&
                !_vm.isAgentBilling
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "7" },
                        on: { click: _vm.doBillPayment }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ApplyForPayment")) + " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isView && !_vm.isAgentBilling
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "8" },
                        on: { click: _vm.printEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingUuid &&
                this.$checkPermission([
                  "button_ACTBilling_updateBillingInputDate"
                ]) &&
                !_vm.isAgentBilling &&
                !_vm.isOcPaymentLock
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "9" },
                        on: {
                          click: function($event) {
                            _vm.showBillDateModifyDialog = true
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_AdjustBillDate")) + " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.isView &&
                _vm.billingUuid &&
                _vm.showSplitBillChargesBtn &&
                _vm.canSplit &&
                _vm.$checkPermission(["button_ACTBilling_splitBillCharges"]) &&
                !_vm.isAgentBilling &&
                !_vm.isOcPaymentLock
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.billing.source === "eTowerOne",
                          type: "primary",
                          no: "10"
                        },
                        on: { click: _vm.splitBillChargesEvent }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_SplitBillingFees")) +
                            " "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm.toExoSystemOC && _vm.isView
                  ? _c(
                      "el-button",
                      {
                        attrs: { no: "showPushResultLog", type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.pushResultLogDialog.visible = true
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PushResultLog")))]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.expandedGrid,
                  expression: "!expandedGrid"
                }
              ],
              staticStyle: { display: "flex" }
            },
            [
              _vm.showBillForm
                ? _c("bill-form", {
                    ref: "billForm",
                    staticStyle: { width: "100%" },
                    attrs: {
                      billing: _vm.billing,
                      "billing-form-params": _vm.billingFormParams,
                      "is-view": _vm.isView,
                      "create-bill-way": _vm.createBillWay,
                      accounts: _vm.accounts
                    },
                    on: {
                      calculateAmount: _vm.calculateAmount,
                      currencyChangeEvent: _vm.currencyChangeEvent,
                      refreshOtherBillingData: _vm.otherBillingData
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "section", staticStyle: { "text-align": "center" } },
            [
              _c("i", {
                class: _vm.expandedGrid
                  ? "el-icon-caret-bottom"
                  : "el-icon-caret-top",
                on: {
                  click: function($event) {
                    _vm.expandedGrid = !_vm.expandedGrid
                  }
                }
              })
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isView,
                  expression: "!isView"
                }
              ],
              staticClass: "section"
            },
            [
              _c(
                "div",
                { staticStyle: { flex: "1" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addBillChargeEvent }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AddBillCharge")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.removeBillChargeEvent }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.reconciliationType === "charge"
                              ? _vm.$t("CargoMsg.Cargo_RemoveBillCharge")
                              : _vm.$t("CargoMsg.Cargo_RemoveAll")
                          ) +
                          " "
                      )
                    ]
                  ),
                  _vm.reconciliationType === "job"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.removePartBillChargeEvent }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ViewDeleteChargeDetail")
                              ) +
                              " "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.billing.uuid &&
                  _vm.$checkPermission(["button_ACTBilling_addAdjustment"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "11" },
                          on: {
                            click: function($event) {
                              return _vm.chargeJustEvent(0)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_IncreaseAdjustment"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.billing.uuid &&
                  _vm.$checkPermission(["button_ACTBilling_editAdjustment"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "12" },
                          on: {
                            click: function($event) {
                              return _vm.chargeJustEvent(1)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_EditAdjustment"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.billing.uuid &&
                  _vm.$checkPermission(["button_ACTBilling_deleteAdjustment"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "13" },
                          on: {
                            click: function($event) {
                              return _vm.chargeJustEvent(2)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_DeleteAdjustment"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.billing.uuid
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "14" },
                          on: { click: _vm.treatmentDiffEvent }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_ProcessingDifference")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.billing.uuid
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "15" },
                          on: { click: _vm.batchUnConfirmBillingEvent }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelConfirm")))]
                      )
                    : _vm._e(),
                  _vm.billing.uuid
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "16" },
                          on: { click: _vm.batchConfirmBillingEvent }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchConfirm")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isView,
                      expression: "isView"
                    }
                  ],
                  staticClass: "section"
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "reconciliationMode" },
                      on: { change: _vm.reconciliationTypeChangeHandler },
                      model: {
                        value: _vm.reconciliationType,
                        callback: function($$v) {
                          _vm.reconciliationType = $$v
                        },
                        expression: "reconciliationType"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { no: "viewedByJob", label: "job" } },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ViewedByJob")))]
                      ),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { no: "viewedByFee", label: "charge" }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ViewedByFee")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module":
                    _vm.reconciliationType === "job" ? "190907" : "190911",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.dynamicColumnDefs,
                  "grid-params": _vm.gridParams,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              }),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end"
                  }
                },
                [
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.dataShow && _vm.totalAmountToCurrency.labelText,
                        expression:
                          "dataShow && totalAmountToCurrency.labelText"
                      }
                    ],
                    domProps: {
                      textContent: _vm._s(_vm.totalAmountToCurrency.labelText)
                    }
                  }),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.dataShow &&
                          _vm.totalAmountToCurrency.selectionCountLabel,
                        expression:
                          "dataShow && totalAmountToCurrency.selectionCountLabel"
                      }
                    ],
                    domProps: {
                      textContent: _vm._s(
                        _vm.totalAmountToCurrency.selectionCountLabel
                      )
                    }
                  }),
                  _c("charge-currency-total-group", {
                    key: 1,
                    attrs: {
                      "amount-to-currency": "",
                      mode: "group",
                      type: "revenueAbs",
                      "data-provider": _vm.totalAmountToCurrency.dataProvider,
                      "data-field": "chargeAmount",
                      "currency-field": _vm.totalAmountToCurrency.currencyField,
                      "ar-field": "chargeReceivable",
                      "show-wht": _vm.showWhtTax
                    }
                  }),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.dataShow &&
                            _vm.rowData &&
                            _vm.rowData.length > 0,
                          expression:
                            "dataShow && rowData && rowData.length > 0"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_ReconciliationAmount"))
                      )
                    ]
                  ),
                  _c("charge-currency-total-group", {
                    key: 2,
                    attrs: {
                      "amount-to-currency": "",
                      mode: "group",
                      type: "revenueAbs",
                      "data-provider": _vm.totalAmountToCurrency.dataProvider,
                      "data-field": "chargeBillingAmount",
                      "currency-field": _vm.totalAmountToCurrency.currencyField,
                      "ar-field": "chargeReceivable"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _c(
          "el-dialog",
          {
            directives: [
              { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
            ],
            attrs: {
              "custom-class": "",
              "close-on-click-modal": false,
              visible: _vm.showBillDateModifyDialog,
              title: _vm.$t("CargoMsg.Cargo_AdjustBillDate"),
              width: "500px"
            },
            on: {
              "update:visible": function($event) {
                _vm.showBillDateModifyDialog = $event
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "app-main-inner-row",
                staticStyle: { "padding-bottom": "10px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "filters" },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          inline: true,
                          "label-width": "90px",
                          "label-position": "left"
                        },
                        nativeOn: {
                          submit: function($event) {
                            $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "el-form-item-wrapper" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.$t("CargoMsg.Cargo_BillDate")
                                }
                              },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "251px" },
                                  attrs: { type: "date", clearable: "" },
                                  model: {
                                    value: _vm.billingDate,
                                    callback: function($$v) {
                                      _vm.billingDate = $$v
                                    },
                                    expression: "billingDate"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { attrs: { slot: "footer" }, slot: "footer" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "17", size: "mini" },
                    on: { click: _vm.updateBillingDateEvent }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", no: "18" },
                    on: {
                      click: function($event) {
                        _vm.showBillDateModifyDialog = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              ],
              1
            )
          ]
        ),
        _vm.writeOffDialog.visible
          ? _c("write-off-dialog", {
              ref: "dgWriteoff",
              attrs: {
                location: _vm.location,
                visible: _vm.writeOffDialog.visible,
                title: _vm.title,
                properties: _vm.properties
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.writeOffDialog, "visible", $event)
                }
              }
            })
          : _vm._e(),
        _vm.showJoinChargeDialog
          ? _c("join-charge-dialog", {
              attrs: {
                visible: _vm.showJoinChargeDialog,
                "search-item-module": _vm.searchItemModule,
                "default-conditions": _vm.addChargeCondition
              },
              on: {
                "update:visible": function($event) {
                  _vm.showJoinChargeDialog = $event
                },
                addChargeCallBackEvent: _vm.addChargeCallBackEvent,
                toSearchTemplate: _vm.toSearchTemplate
              }
            })
          : _vm._e(),
        _vm.showJobChargeAdjustmentDialog
          ? _c("job-charge-adjustment-dialog", {
              attrs: {
                visible: _vm.showJobChargeAdjustmentDialog,
                "default-properties": _vm.defaultProperties
              },
              on: {
                "update:visible": function($event) {
                  _vm.showJobChargeAdjustmentDialog = $event
                },
                jobChargeAdjustmentCallBackEvent: _vm.chargeJustCallBackEvent
              }
            })
          : _vm._e(),
        _vm.showChargeAdjustmentDialog
          ? _c("charge-adjustment-dialog", {
              attrs: {
                visible: _vm.showChargeAdjustmentDialog,
                "default-properties": _vm.defaultProperties
              },
              on: {
                "update:visible": function($event) {
                  _vm.showChargeAdjustmentDialog = $event
                },
                chargeAdjustmentCallBackEvent: _vm.chargeJustCallBackEvent
              }
            })
          : _vm._e(),
        _vm.showRemovePartBillChargeDialog
          ? _c("remove-part-bill-charge-dialog", {
              attrs: {
                visible: _vm.showRemovePartBillChargeDialog,
                "part-charges": _vm.partCharges
              },
              on: {
                "update:visible": function($event) {
                  _vm.showRemovePartBillChargeDialog = $event
                },
                removePartBillChargeCallBackEvent:
                  _vm.removePartBillChargeCallBackEvent
              }
            })
          : _vm._e(),
        _vm.showConflictChargeDialog
          ? _c("conflict-charges-dialog", {
              attrs: {
                visible: _vm.showConflictChargeDialog,
                charges: _vm.conflictCharges,
                "view-source": "billingDetail"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showConflictChargeDialog = $event
                },
                conflictChargeCallBackEvent: _vm.conflictChargeCallBackEvent
              }
            })
          : _vm._e(),
        _vm.showChargeSplitByJobDialog
          ? _c("charge-split-by-job-dialog", {
              attrs: {
                visible: _vm.showChargeSplitByJobDialog,
                "except-keys": _vm.exceptKeys,
                "view-source": "billingDetail"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showChargeSplitByJobDialog = $event
                },
                chargeSplitByJobCallBackEvent: _vm.chargeSplitByJobCallBackEvent
              }
            })
          : _vm._e(),
        _vm.showChargeSplitByChargeDialog
          ? _c("charge-split-by-charge-dialog", {
              attrs: {
                visible: _vm.showChargeSplitByChargeDialog,
                "old-charge": _vm.spiltCharge,
                location: _vm.location,
                "view-source": "billingDetail"
              },
              on: {
                "update:visible": function($event) {
                  _vm.showChargeSplitByChargeDialog = $event
                },
                chargeSplitByChargeCallBackEvent:
                  _vm.chargeSplitByChargeCallBackEvent
              }
            })
          : _vm._e(),
        _c("make-invoice-dialog", {
          ref: "invoice",
          attrs: { location: _vm.location }
        }),
        _c("cargo-template-selector-dialog", {
          ref: "cargoTemplateSelectorDialog",
          attrs: {
            visible: _vm.templateSelectorDialog.visible,
            ctx: _vm.templateSelectorDialog.cxt,
            category: _vm.templateSelectorDialog.category,
            data: _vm.templateSelectorDialog.data,
            "pre-print-callback": _vm.prePrintCallback
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
            }
          }
        }),
        _c("bill-payment-dialog", {
          ref: "billPayment",
          attrs: {
            visible: _vm.showBillPaymentDialog,
            "create-submit": true,
            location: _vm.location,
            step: "step2",
            mode: "overview"
          },
          on: {
            "update:visible": function($event) {
              _vm.showBillPaymentDialog = $event
            },
            cancel: _vm.cancelBillPayment
          }
        }),
        _vm.pushResultLogDialog.visible
          ? _c("push-result-log-dialog", {
              attrs: {
                visible: _vm.pushResultLogDialog.visible,
                "job-uuid": _vm.billing.uuid || "",
                "log-source": "billing"
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.pushResultLogDialog, "visible", $event)
                }
              }
            })
          : _vm._e(),
        _vm.batchCheckingWindow.visible
          ? _c("batch-checking-window", {
              attrs: {
                visible: _vm.batchCheckingWindow.visible,
                lob: _vm.batchCheckingWindow.lob,
                jobs: _vm.batchCheckingWindow.jobs,
                billing: _vm.billing,
                "check-node": _vm.batchCheckingWindow.checkNode,
                "call-back": _vm.batchCheckingWindow.callBack,
                "call-back2": _vm.batchCheckingWindow.callBack2
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
                }
              }
            })
          : _vm._e(),
        _vm.checkingSaveJobWindow.visible
          ? _c("checking-save-job-window", {
              attrs: {
                visible: _vm.checkingSaveJobWindow.visible,
                lob: _vm.checkingSaveJobWindow.lob,
                "row-data": _vm.checkingSaveJobWindow.rowData,
                "check-node": _vm.checkingSaveJobWindow.checkNode,
                "call-back": _vm.checkingSaveJobWindow.callBack
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }